import React from 'react';

import CustomSpinner, { CustomSpinnerColor } from '@components/Spinner/CustomSpinner';
import SuggestedAiPromptCard from '@components/SuggestedAiPromptCard';
import { SuggestedAiPromptCardAs } from '@components/SuggestedAiPromptCard/constants';
import { SuggestedAiPromptsProps } from '@components/SuggestedAiPromptCard/interfaces';
import useEventTracking from '@hooks/useEventTracking';
import { useSuggestedAiPrompts } from '@hooks/useSuggestedAiPrompts';
import { TrackingLocation } from '@tracking';

const Suggested = ({
  disablePrompts,
  setSuggestedPrompt,
  hideLoader = false,
}: SuggestedAiPromptsProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.SuggestedPrompts,
  });

  const handleSuggestionClick = (prompt: string) => {
    setSuggestedPrompt(prompt);
  };

  const { isLoadingSuggestedAiPrompts, suggestedAiPrompts } = useSuggestedAiPrompts();

  return (
    <Track>
      <article className="relative mx-auto mt-16 flex w-full flex-nowrap justify-between gap-24 overflow-x-auto sm:mt-28 sm:flex-wrap sm:overflow-x-hidden md:flex-nowrap">
        {isLoadingSuggestedAiPrompts && !hideLoader ? (
          <div className="mx-auto mt-8 pt-16">
            <CustomSpinner size={10} color={CustomSpinnerColor.PrimaryMagenta} />
          </div>
        ) : (
          suggestedAiPrompts.map((suggestedPrompt) => (
            <SuggestedAiPromptCard
              key={suggestedPrompt.iconPngUrl}
              as={SuggestedAiPromptCardAs.Button}
              className="w-[76vw] flex-shrink-0 xs:w-[50vw] sm:w-[calc(50%_-_12px)] md:flex-shrink"
              disablePrompts={disablePrompts}
              handleSuggestionClick={handleSuggestionClick}
              suggestedAiPrompt={suggestedPrompt}
            />
          ))
        )}
      </article>
    </Track>
  );
};

export default Suggested;
